export default __webpack_public_path__ + "static/media/push-notifications-rafiki.f36c5e95.png";